export class BoardingPlaceDensityOfPeopleFactorData
{
    colId:number;
    transportModeId:number;
    value:number;
}